import type { IBaseNotary } from "../../BaseNotaryFactory";
import type { DeedType } from "le-coffre-resources/dist/Notary";
import type { QueryPayload } from "@Front/Api/types";
import type {
	IGetDeedTypesParams,
	IPutDeedTypesParams,
	IPostDeedTypesParams,
	DeedTypeListSettings,
	DeedTypeListSettingsPayload,
} from "../DeedTypes";
import {
	buildDeedTypesCreatePayload,
	buildDeedTypesUpdatePayload,
} from "@Front/Api/LeCoffreApi/helpers/businessRequestPayloadHelpers";

export function createGetMethod(baseNotary: IBaseNotary, baseUrl: string) {
	return async (q?: IGetDeedTypesParams): Promise<DeedType[]> => {
		const url = new URL(baseUrl);
		const query = { q };
		if (q) baseNotary.appendJsonSearchParams(url, query);
		try {
			return await baseNotary.getRequest<DeedType[]>(url);
		} catch (err) {
			baseNotary.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createGetByUidMethod(baseNotary: IBaseNotary, baseUrl: string) {
	return async (uid: string, q?: QueryPayload): Promise<DeedType> => {
		const url = new URL(baseUrl.concat(`/${uid}`));
		if (q) baseNotary.appendJsonSearchParams(url, q);
		try {
			return await baseNotary.getRequest<DeedType>(url);
		} catch (err) {
			baseNotary.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createPutMethod(baseNotary: IBaseNotary, baseUrl: string) {
	return async (uid: string, body: IPutDeedTypesParams): Promise<DeedType> => {
		const url = new URL(baseUrl.concat(`/${uid}`));
		try {
			const payload = buildDeedTypesUpdatePayload(body);
			return await baseNotary.putRequest<DeedType>(url, payload);
		} catch (err) {
			baseNotary.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createPostMethod(baseNotary: IBaseNotary, baseUrl: string) {
	return async (body: IPostDeedTypesParams): Promise<DeedType> => {
		const url = new URL(baseUrl);
		try {
			const payload = buildDeedTypesCreatePayload(body);
			return await baseNotary.postRequest<DeedType>(url, payload);
		} catch (err) {
			baseNotary.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createGetListSettingsMethod(baseNotary: IBaseNotary, baseUrl: string) {
	return async (uid: string): Promise<DeedTypeListSettings | null> => {
		const url = new URL(baseUrl.concat(`/${uid}/list-settings`));
		try {
			const data = await baseNotary.getRequest<DeedTypeListSettings | null>(url);
			return data;
		} catch (err) {
			baseNotary.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createPutListSettingsMethod(baseNotary: IBaseNotary, baseUrl: string) {
	return async (uid: string, body: DeedTypeListSettingsPayload): Promise<DeedTypeListSettings> => {
		const url = new URL(baseUrl.concat(`/${uid}/list-settings`));
		try {
			return await baseNotary.putRequest<DeedTypeListSettings>(url, body);
		} catch (err) {
			baseNotary.onError(err);
			return Promise.reject(err);
		}
	};
}
